<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="add new audit">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>

        <v-progress-linear :value="percentage" color="#5d58ef" height="10">
          <strong class="percentage">{{ Math.ceil(percentage) }}%</strong>
        </v-progress-linear>

        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <!-- <v-col cols="12" sm="4">

              <v-text-field label="Title *" v-model="formData.auditTitle" color="#5d58ef">
              </v-text-field>
            </v-col> -->
            <v-col cols="12" md="3">
              <v-autocomplete label="Select acadamic year *" clearable
                v-model="formData.academicYearID" :items="acadamicYearData"
                v-on:change="getTeacherList();getClassList();isAuditExist()" key="id"
                item-value="id" item-text="academicYear">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete label="Center *" clearable v-model="formData.franchiseeID"
                :items="centreList" v-on:change="getTeacherList();getClassList();isAuditExist()"
                key="id" item-value="id" item-text="companyName">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete label="Teacher *" v-on:change="getClassList();isAuditExist()"
                clearable v-model="formData.auditeeID" :items="teacherList" key="user.id"
                item-value="user.id" item-text="user.firstName">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete label="Select Class *" clearable v-model="formData.classID"
                :items="classList" v-on:change="getCategories();isAuditExist()" key="id"
                item-value="id" item-text="name">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu disabled ref="menu1" v-model="menu1" :close-on-content-click="false"
                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field disabled v-model="formData.auditDate" label="Select Date *"
                    persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker disabled v-model="date" no-title @input="menu1 = false">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="3">
              <v-autocomplete v-on:change="getCategories();isAuditExist()" label="Type *"
                v-model="formData.type" :items="typeOptions">
              </v-autocomplete>
            </v-col>
          </v-row>
          <!--+++++++++++++++++++++++++++Category Fields Start++++++++++++++++++++++++++++++++++++++++++-->
          <v-container v-for="item in categoryData" :key="item.id">
            <v-row>
              <v-col>
                <p class="mb-0 mt-5" style="width: 100%;">
                  <strong class="header-title ml-3">
                    <v-icon>mdi-checkbox-marked</v-icon> {{item.name}}
                  </strong>

                </p>

              </v-col>
              <v-col cols="12" md="3">
                {{item.score}}
                <!-- <v-autocomplete label="Select Score" clearable v-model="item.score"
                    :items="scoreList" v-on:change="getTeacherList()" key="id" item-value="value"
                    item-text="value">
                  </v-autocomplete> -->
              </v-col>
            </v-row>
            <!-- <v-divider class="my-0 hr-divider" /> -->
            <v-data-table :headers="headers" :items="item.acadAuditParameters" disable-pagination
              hide-default-footer>
              <template v-slot:item.score="{item}">
                <v-autocomplete label="Select Score" clearable v-model="item.score"
                  v-on:change="formProgressCaluculation()" :items="scoreList" key="id"
                  item-value="value" item-text="label"> </v-autocomplete>
              </template>
            </v-data-table>
            <v-col class="pl-0 pr-0" cols="12">
              <v-text-field v-on:change="formProgressCaluculation()" v-model="item.remark"
                label="Remarks" color="#5d58ef" outlined max='255'
                oninput="if(Number(this.value.toString().length) > Number(this.max)) this.value = this.value.slice(0, this.max);">
              </v-text-field>
            </v-col>
          </v-container>
          <!--+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
          <v-col class="pl-0 pr-0" cols="12">
            <v-text-field v-model="formData.overallRemark" label="Overall Remarks" color="#5d58ef"
              outlined>
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-card-actions class="d-flex justify-end">
              <v-btn bottom @click="saveAsDraft" right elevation="1" color="primary" type="button">
                <v-icon left> mdi-content-save </v-icon>
                Save as draft
              </v-btn>
              <v-btn bottom right elevation="1" color="primary" type="submit">
                <v-icon left>mdi-clipboard-edit-outline </v-icon>
                Submit
              </v-btn>
            </v-card-actions>
          </v-col>

        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import { mapGetters } from 'vuex'
// import _ from 'lodash'
import stores from '@/stores'
// import moment from 'moment'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['type'],
  data () {
    return {
      percentage: 0,
      centreList: [],
      classList: [],
      teacherList: [],
      isLoading: false,
      alerted: false,
      categoryData: [],
      acadamicYearData: [],
      scoreList: [],
      formData: {
        academicYearID: '',
        franchiseeID: '',
        auditeeID: '',
        classID: '',
        auditDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        type: this.$route.params.type.toString(),
        overallRemark: ''
      },
      validationErrors: {
        academicYearID: 'Academic Year ID',
        franchiseeID: 'Center',
        auditeeID: 'Teacher',
        classID: 'Class ID',
        auditDate: 'Audit date',
        type: 'Type',
        overallRemark: 'Overall remark',
        score: 'Parameter score'
      },
      typeOptions: ['online', 'offline'],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu1: false,
      noOfFields: 0,
      headers: [
        { text: 'Parameter', value: 'name', sortable: false, width: '70%' },
        { text: 'Score', value: 'score', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    formData: {
      handler: function () {
        this.formProgressCaluculation()
      },
      deep: true
    },
    academicYear: function (val) {
      if (val) {
        console.log('____Academic ID____', val.academicYear)
        // this.formData.academicYearID = val.id
        this.getTeacherList()
      }
    }
  },
  created: async function () {
    console.log(`Type: ${this.$route.params.type}`)
    this.formProgressInit()
    await this.getFranchisee()
    await this.getCategories()
    await this.getAcadamicYearsList()
    await this.getScoreList()
  },
  methods: {
    async save () {
      try {
        console.log('____Save____')
        if (this.formValidation()) {
          let parameter = []
          let category = this.categoryData.map((item) => {
            parameter = item.acadAuditParameters.map((ele) => {
              return {
                parameterID: ele.id,
                parameter: ele.name,
                score: ele.score,
                position: ele.position
              }
            })
            return {
              categoryID: item.acadAuditCategory.id,
              categoryName: item.name,
              // score: item.score,
              remark: item.remark || '',
              parameter: parameter,
              position: item.position
            }
          })
          let obj = {
            category: category,
            academicYearID: this.formData.academicYearID,
            classID: this.formData.classID,
            auditeeID: this.formData.auditeeID,
            franchiseeID: this.formData.franchiseeID,
            // auditedBy: stores.user.me.id,
            // auditTitle: this.formData.auditTitle,
            auditDate: this.formData.auditDate,
            isPublish: true,
            overallRemark: this.formData.overallRemark,
            // status: 'NA',
            type: this.formData.type,
            isActive: true
          }
          console.log('___Request___', obj)
          let res = await http.post(`${CONSTANTS.API_URL}/api/center-audit/audit`, obj)
          console.log('___Response___', res.data)
          this.okMsg(res.data)
          this.$router.push({ name: 'acadAudits', params: { type: 'online' } })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    async saveAsDraft () {
      console.log('____Save as draft____')
      try {
        if (this.draftValidation()) {
          let parameter = []
          let category = this.categoryData.map((item) => {
            parameter = item.acadAuditParameters.map((ele) => {
              return {
                parameterID: ele.id,
                parameter: ele.name,
                score: ele.score || 0,
                position: ele.position
              }
            })
            return {
              categoryID: item.acadAuditCategory.id,
              categoryName: item.name,
              // score: item.score,
              remark: item.remark || '',
              parameter: parameter,
              position: item.position
            }
          })
          let obj = {
            category: category,
            academicYearID: this.formData.academicYearID,
            classID: this.formData.classID,
            auditeeID: this.formData.auditeeID,
            franchiseeID: this.formData.franchiseeID,
            // auditedBy: stores.user.me.id,
            // auditTitle: this.formData.auditTitle,
            auditDate: this.formData.auditDate,
            isPublish: false, // Draft
            overallRemark: this.formData.overallRemark,
            // status: 'NA',
            type: this.formData.type,
            isActive: true
          }
          console.log('___Request___', obj)
          let res = await http.post(`${CONSTANTS.API_URL}/api/center-audit/audit`, obj)
          this.okMsg(res.data)
          this.$router.push({ name: 'acadAudits', params: { type: 'All' } })
        } else {
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    draftValidation () {
      let message = ''
      if (!this.formData.classID) {
        message = 'Please select a class ID'
      } else if (!this.formData.type) {
        message = 'Please select a audit type'
      } else if (!this.formData.auditeeID) {
        message = 'Please select a auditee'
      } else if (!this.formData.franchiseeID) {
        message = 'Please select a center.'
      } else if (!this.formData.auditDate) {
        message = 'Please select a audit date.'
      } else if (this.categoryData.length === 0) {
        message = 'There are no parameters to audit'
      }
      if (message !== '') {
        this.$buefy.toast.open({
          message: message,
          type: 'is-danger',
          duration: 4000
        })
      }
      return message === ''
    },
    async getScoreList () {
      let rows = await http.get(`${CONSTANTS.API_URL}/api/center-audit/score/points`)
      this.scoreList = rows.data.map((item) => {
        item.label = parseInt(item.value) === 0 ? 'NA' : item.value
        return item
      })
    },
    async getTeacherList () {
      this.formData.academicYearID = this.academicYear.id
      if (this.formData.franchiseeID && this.formData.academicYearID) {
        // staff/teacher-class-map
        let rows = await http.get(`${CONSTANTS.API_URL}/api/staff/approved`, {
          params: {
            franchiseeID: this.formData.franchiseeID,
            isTeachingStaff: true
          }
        })
        console.log('____Teacher list___', rows.data)
        this.teacherList = rows.data
        this.getClassList()
      }
    },
    async getClassList () {
      this.formData.academicYearID = this.academicYear.id
      // if (this.formData.franchiseeID && this.formData.academicYearID) {
      //   let rows = await http.get(`${CONSTANTS.API_URL}/api/student/get-all-classby-franchisee`, {
      //     params: {
      //       franchiseeID: this.formData.franchiseeID,
      //       academicYearID: this.formData.academicYearID
      //     }
      //   })
      //   console.log('___Class List___', rows.data)
      //   this.classList = rows.data
      // }
      if (this.formData.franchiseeID && this.formData.academicYearID) {
        let rows = await http.get(`${CONSTANTS.API_URL}/api/staff/teacher-class-map`, {
          params: {
            franchiseeID: this.formData.franchiseeID,
            academicYearID: this.formData.academicYearID,
            userID: this.formData.auditeeID,
            isActive: true
          }
        })
        console.log('___Class List___', rows.data)
        this.classList = rows.data.map((item) => {
          return item.studentSection.studentClass
        })
      }
    },
    formProgressInit () {
      this.noOfFields = Object.keys(this.formData).length
      this.categoryData.forEach((element) => {
        element.acadAuditParameters = element.acadAuditCategory.acadAuditParameters.map((item) => {
          item.score = ''
          this.noOfFields++
          return item
        })
      })
      this.noOfFields += this.categoryData.length
    },
    formValidation () {
      let invalidFieldCount = 0
      let invalidFields = []
      let tempKey = ''
      Object.keys(this.formData).map((key) => {
        if (!this.formData[key]) {
          if (key !== 'overallRemark') {
            invalidFields.push(key)
            invalidFieldCount++
          } else {
            // Pushing overallRemark to the end of array as it is positioned at the end of the page
            tempKey = key
          }
        }
      })
      this.categoryData.forEach((element) => {
        // Remark field is made optional
        // if (!element.remark) {
        //   invalidFieldCount++
        // }
        // if (element.score === 'NA') {
        //   invalidFieldCount++
        // }
        element.acadAuditParameters.map((item) => {
          if (!item.score) {
            invalidFields.push('score')
            invalidFieldCount++
          }
        })
      })
      if (tempKey) {
        invalidFields.push(tempKey)
      }
      let filledFields = this.noOfFields - invalidFieldCount
      this.percentage = (filledFields / this.noOfFields) * 100
      // console.log('Total Fields: ', this.noOfFields)
      console.log('Invalid Fields: ', invalidFieldCount)
      // console.log('Filled Fields: ', filledFields)
      // console.log('Percentage: ', this.percentage)
      // this.isAuditExist()
      if (invalidFields.length > 0) {
        this.errMsg(`${this.validationErrors[invalidFields[0]]} is required!`)
      }
      console.log(invalidFields)
      return this.noOfFields === filledFields
    },
    formProgressCaluculation () {
      let invalidFieldCount = 0
      Object.keys(this.formData).map((key) => {
        if (!this.formData[key]) {
          invalidFieldCount++
        }
      })
      this.categoryData.forEach((element) => {
        // Remark field is made optional
        // if (!element.remark) {
        //   invalidFieldCount++
        // }
        // if (element.score === 'NA') {
        //   invalidFieldCount++
        // }
        element.acadAuditParameters.map((item) => {
          if (!item.score) {
            invalidFieldCount++
          }
        })
      })
      let filledFields = this.noOfFields - invalidFieldCount
      this.percentage = (filledFields / this.noOfFields) * 100
      // console.log('Total Fields: ', this.noOfFields)
      console.log('Invalid Fields: ', invalidFieldCount)
      // console.log('Filled Fields: ', filledFields)
      // console.log('Percentage: ', this.percentage)
      // this.isAuditExist()
      return this.noOfFields === filledFields
    },
    isAuditExist: async function () {
      try {
        if (this.formData.franchiseeID && this.formData.academicYearID && this.formData.classID && this.formData.auditeeID && this.formData.auditDate && !this.alerted) {
          let { data } = await http.get(`${CONSTANTS.API_URL}/api/center-audit/audit/isAuditExist`, {
            params: {
              franchiseeID: this.formData.franchiseeID,
              academicYearID: this.formData.academicYearID,
              classID: this.formData.classID,
              auditeeID: this.formData.auditeeID,
              auditDate: this.formData.auditDate,
              type: this.formData.type
            }
          })
          let message = 'Audit already exist with the given details!'
          let flag = false
          data.rows = data.rows.filter((item) => {
            return item.auditedBy === stores.user.me.id && item.isPublish === false
          })
          flag = data.rows.length > 0
          if (data.count > 0) {
            // this.alerted = true
            if (!flag) {
              return this.$buefy.dialog.alert({
                type: 'is-warning',
                message: message,
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            } else {
              let that = this
              this.$buefy.dialog.confirm({
                message: 'Audit already exist in the drafts.',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true,
                confirmText: 'Proceed to drafts',
                onConfirm: async function () {
                  that.$router.push({ name: 'auditDrafts' })
                }
              })
            }
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    getCategories: async function () {
      try {
        if (this.formData.classID && this.formData.academicYearID) {
          let data = await http.get(`${CONSTANTS.API_URL}/api/center-audit/category/classes`, {
            params: {
              classID: this.formData.classID,
              academicYearID: this.formData.academicYearID,
              type: this.formData.type // this.$route.params.type.toString()
            }
          })
          this.categoryData = []
          this.categoryData = data.data
          this.categoryData = this.categoryData.map((item) => {
            item.name = item.acadAuditCategory.name
            return item
          })
          this.formProgressInit()
          this.formProgressCaluculation()
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/franchisee`)
        this.centreList = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    getAcadamicYearsList: async function () {
      let rows = await http.get(`${CONSTANTS.API_URL}/api/franchiseeAcademicYears`, {
        params: {
          isCurrentAcademicYear: true
        }
      })
      this.acadamicYearData = rows.data.rows
      this.formData.academicYearID = this.acadamicYearData[1] ? this.acadamicYearData[1].id : ''
      console.log('___Acad Years__', this.acadamicYearData)
    }
  }
}
</script>

<style scoped>
.header-title {
  font-size: 16px;
  color: dimgray;
}
.hr-divider {
  border: solid white;
  border-bottom: solid 3px rgba(0, 0, 0, 0.42);
}
.theme--light.v-sheet--outlined {
  border: none !important;
}
.percentage {
  color: #fff;
  font-size: 9px;
}
</style>
